import { render, staticRenderFns } from "./IntegrationSelect.vue?vue&type=template&id=2fce815b&scoped=true&"
import script from "./IntegrationSelect.vue?vue&type=script&lang=js&"
export * from "./IntegrationSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fce815b",
  null
  
)

export default component.exports